/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { useEffect, useState } from 'react';
import { AuthStorage } from '../services/storage/auth.storage';

const useAuthUser = () => {
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    setAuthUser(AuthStorage.getUser());
  }, []);

  return authUser;
};

export default useAuthUser;
